// extracted by mini-css-extract-plugin
module.exports = {"container":"company-module--container--3qxtr","container__photo":"company-module--container__photo--TSuWQ","containerPhoto":"company-module--container__photo--TSuWQ"};